import DataStore from '@/engine/stores/data-store';

class TemplateListDataStore extends DataStore {
}

export default new TemplateListDataStore();
